import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import { useEffect, useState } from 'react';

import { VersionBadge } from '@/components/VersionBadge';

function App() {
  const [subdomain, setSubdomain] = useState<string>('');

  useEffect(() => {
    const host = window.location.host;

    setSubdomain(host.split('.').slice(0, host.includes('localhost') ? -1 : -2)[0]);
  }, []);

  return (
    <AppProvider>
      <div className="flex flex-col h-screen overflow-hidden">
        {(subdomain.includes('react') || subdomain.includes('-dev')) && (
          // Warning showing the user is on a dev subdomain
          <div className="bg-red-500 text-white text-center p-2 pointer-events-none opacity-80 text-sm shrink-0">
            You are on a development subdomain. Please contact Vivid Vision support if you are not a developer or QA tester.
          </div>
        )}
        <div className="flex-1 overflow-auto">
          <AppRoutes />
        </div>
        <VersionBadge />
      </div>
    </AppProvider>
  );
}

export default App;
